import $ from 'jquery';
import ClipboardJS from 'clipboard';
export default class CopyInputValue {
    static init() {
        $('.js__data-copy').each((i, element) => {
            const clipboardData = new ClipboardJS(element);
            this.showSuccess(clipboardData, $(element));
        });
    }
    static showSuccess(clipboard, $target) {
        clipboard.on('success', () => {
            $target.popup({
                content: $target.data('success-description'),
            });
            $target.popup('show');
            setTimeout(() => {
                $target.popup('destroy');
            }, 1500);
        });
    }
}
